"use client";

import { useEffect } from "react";
import { useSearchParams, useRouter, usePathname } from "next/navigation";

export default function GiftActivatedRefresh() {
    const searchParams = useSearchParams();
    const router = useRouter();
    const pathname = usePathname();

    useEffect(() => {
        if (searchParams.get("gift_activated") === "1") {
            // Create new URL without gift_activated param
            const params = new URLSearchParams(searchParams.toString());
            params.delete("gift_activated");

            const newUrl = params.toString()
                ? `${pathname}?${params.toString()}`
                : pathname;

            router.replace(newUrl);
        }
    }, [searchParams, router, pathname]);

    return null;
}
